<template>
  <div class="animated fadeIn col-md-12">
    <SearchCard
      :filterCatch="filterCache"
      :hasFilter="filterCache"
      :title="title"
      :extraButtons="extraButtons"
      :url="url"
      cardClass="border-0 p-3"
      ref="searchParvandeh"
      @updatePermissions="updatePermissions"
      :hasAdd="!isParvandehArchive"
      @handleAdd="showAddModal"
      @getOther="updateOtherData"
    >
      <template slot="html" slot-scope="{ item }">
        <b-col
          cols="12"
          md="12"
          class="mb-3 pb-3 px-0 border border-top-0 border-right-0 border-left-0 border-light"
        >
          <b-row align-h="center">
            <b-col cols="" md="" class="fs_1rem font-weight-bold pb-md-0 pb-3">
              <span v-html="generateParvandehTitle(item)" />
            </b-col>
            <b-col cols="auto" md="auto">
              <span
                :class="`w-auto d-flex align-items-center justify-content-between badge_style badge_style--${
                  pathOr(1, ['parvandeh_status', 'id'], item) === 1
                    ? 'success'
                    : 'danger'
                }`"
              >
                <mdicon
                  v-if="pathOr(1, ['parvandeh_status', 'id'], item) === 1"
                  name="folder-open-outline"
                  size="20"
                  class="mr-1"
                />
                <mdicon
                  v-else
                  name="folder-remove-outline"
                  size="20"
                  class="mr-1"
                />
                <span
                  v-b-tooltip.hover
                  :title="`${pathOr(
                    '',
                    ['parvandeh_status', 'caption'],
                    item
                  )} ${
                    item.status_end_reason
                      ? `علت مختومه شدن (${pathOr(
                          '',
                          ['status_end_reason', 'caption'],
                          item
                        )})`
                      : ``
                  }`"
                  v-text="pathOr('', ['parvandeh_status', 'caption'], item)"
                />
              </span>
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="12" md="2" class="text-md-left text-center p-0">
          <b-img-lazy
            fluid
            thumbnail
            :onerror="$config.images.onerrorDefaultImg"
            :src="generateImage(item)"
            class="bg-white personal_image object__fit--cover"
          />
        </b-col>
        <b-col cols="12" md="10" class="px-0">
          <b-row>
            <b-col cols="12" md="8" class="py-2">
              <i class="far fa-check-circle mr-1" />
              <b v-text="$lang.name_family" />:
              <ProfileBoxPopupWrapper
                :data="item"
                deskTopPopupClass="top-230"
                nameClass="color-complementary"
              />
            </b-col>
            <b-col cols="12" md="4" class="py-2">
              <i class="far fa-check-circle mr-1" />
              <b v-text="$lang.national_code" />:
              <span class="text-muted" v-text="item.person.national_code" />
            </b-col>
            <b-col cols="12" md="4" class="py-2" v-if="item.total_item">
              <i class="far fa-check-circle mr-1" />
              <b v-text="$lang.total_number_sections" />:
              <span class="text-muted" v-text="item.total_item" />
            </b-col>
            <b-col cols="12" md="4" class="py-2" v-if="item.total_item">
              <i class="far fa-check-circle mr-1" />
              <b v-text="$lang.number_defects" />:
              <span class="text-muted" v-text="item.incomplete_item" />
            </b-col>
            <b-col cols="12" md="4" class="py-2" v-if="item.total_item">
              <i class="far fa-check-circle mr-1" />
              <b v-text="$lang.percentage_completion" />:
              <span
                class="text-muted"
                v-text="
                  `${calcPercentage(+item.total_item, +item.incomplete_item)}%`
                "
              />
            </b-col>
            <b-col v-if="item.roles.length" cols="12" md="12" class="py-2">
              <i class="far fa-check-circle mr-1" />
              <b v-text="$lang.roles" />:
              <b-badge
                v-for="(role, i) in item.roles"
                :key="i"
                variant="secondary"
                class="m-1 p-1"
              >
                {{ role }}
              </b-badge>
            </b-col>
            <b-col cols="12" class="py-2" v-if="item.comment">
              <i class="far fa-check-circle mr-1" />
              <b v-text="$lang.profileLang.description" />:
              <span class="text-muted" v-text="item.comment" />
            </b-col>
            <b-col cols="12" class="py-2" v-if="item.tags.length">
              <i class="far fa-check-circle mr-1" />
              <b v-text="$lang.profileLang.tags" />:
              <b-badge
                v-for="(tag, key) in item.tags"
                :key="key"
                variant="success"
                class="mr-2"
              >
                <i class="fas fa-tag mr-1" />
                <span v-text="tag.caption" />
              </b-badge>
            </b-col>
            <b-col
              v-if="
                item.parvandeh_status.id === 2 &&
                pathOr(null, ['cancel', 'description'], item)
              "
              cols="12"
              class="py-1"
            >
              <i class="far fa-check-circle mr-1" />
              <b v-text="$lang.reason_cancellation" />:
              <span
                class="text-muted"
                v-text="pathOr('', ['cancel', 'description'], item)"
              />
            </b-col>
            <b-col
              v-if="
                item.parvandeh_status.id === 2 &&
                pathOr(null, ['cancel', 'cancel_at'], item)
              "
              cols="12"
              class="py-1"
            >
              <i class="far fa-check-circle mr-1" />
              <b v-text="$lang.date_cancellation" />:
              <span
                class="text-muted"
                v-text="pathOr('', ['cancel', 'cancel_at', 'jalali'], item)"
              />
            </b-col>
          </b-row>
        </b-col>
        <b-col
          cols="12"
          md="12"
          class="text-right pt-3 mt-3 px-0 border border-bottom-0 border-right-0 border-left-0 border-light"
        >
          <b-row align-v="center">
            <b-col
              cols="12"
              md="auto"
              class="text-md-left text-center text-muted pb-md-0 pb-3 d-flex align-items-center justify-content-center"
            >
              <div
                v-b-tooltip
                :title="$lang.created_by"
                v-if="
                  pathOr(null, ['created_by'], item) &&
                  pathOr(null, ['created_by'], item) !== getFullName(item)
                "
                class="mr-2"
              >
                <mdicon name="account-edit-outline" size="20" class="mr-1" />
                <span v-text="pathOr('', ['created_by'], item)" />
              </div>
              <div v-b-tooltip :title="$lang.create_time">
                <mdicon name="clock-edit-outline" size="20" class="mr-1" />
                <span
                  v-html="
                    createDateFormat(pathOr([], ['created_at', 'jalali'], item))
                  "
                />
              </div>
            </b-col>
            <b-col
              cols="12"
              md=""
              class="text-md-right text-center text-muted pb-md-0"
            >
              <ExpandButton
                variant="success"
                :expandable="true"
                :expanded="false"
                :disabled="false"
                :circle="true"
                :loading="false"
                icon="folder-edit-outline"
                :text="$lang.edit"
                :tooltip="$lang.edit"
                cls="mx-1"
                :condition="isAdmin(permissions)"
                @click="showEditModal(item)"
              />
              <ExpandButton
                variant="info"
                :expandable="true"
                :expanded="false"
                :disabled="false"
                :circle="true"
                :loading="false"
                icon="monitor-dashboard"
                :text="$lang.show_in_dashboard"
                :tooltip="$lang.show_in_dashboard"
                cls="mx-1"
                :condition="isAdmin(permissions, ['admin'])"
                @click="goToReportDashboard(item)"
              />
              <ExpandButton
                variant="info"
                :expandable="true"
                :expanded="false"
                :disabled="false"
                :circle="true"
                :loading="false"
                icon="account-details-outline"
                :text="$lang.person_info_pdf"
                :tooltip="$lang.person_info_pdf"
                cls="mx-1"
                :condition="isAdmin(permissions, ['admin'])"
                @click="showPdfPerson(item)"
              />
              <ExpandButton
                variant="info"
                :expandable="true"
                :expanded="false"
                :disabled="false"
                :circle="true"
                :loading="false"
                icon="folder-information-outline"
                :text="$lang.parvandeh_show_incompletes"
                :tooltip="$lang.parvandeh_show_incompletes"
                cls="mx-1"
                @click="showIncompleteParvandehModal(item)"
              />
              <ExpandButton
                variant="warning"
                :expandable="true"
                :expanded="false"
                :disabled="false"
                :circle="true"
                :loading="false"
                icon="cloud-upload-outline"
                :text="$lang.upload_ready_report"
                :tooltip="$lang.upload_ready_report"
                cls="mx-1"
                :condition="
                  isAdmin(permissions, ['admin']) &&
                  pathOr(false, ['can_upload_report'], otherData)
                "
                @click="showUploadReportModal(item)"
              />
              <ExpandButton
                variant="primary"
                :expandable="true"
                :expanded="false"
                :disabled="false"
                :circle="true"
                :loading="false"
                icon="clipboard-list-outline"
                :text="$lang.reports"
                :tooltip="$lang.reports"
                cls="mx-1"
                :condition="isAdmin(permissions, ['admin'])"
                @click="showReports(item)"
              />
            </b-col>
          </b-row>
        </b-col>
      </template>
    </SearchCard>
    <b-modal
      no-close-on-backdrop
      variant="primary"
      header-bg-variant="primary"
      content-class="border-primary"
      v-model="editModal"
      size="lg"
      ok-only
      hide-footer
      hide-header
    >
      <EditCooperatorParvandehForm
        :parentPermissions="permissions"
        :parvandehName="parvandehName"
        :parvandehCode="parvandehCode"
        @closeModal="editModal = false"
        @getData="getData"
      />
    </b-modal>
    <b-modal
      no-close-on-backdrop
      variant="primary"
      header-bg-variant="primary"
      content-class="border-primary"
      v-model="addModal"
      size="lg"
      ok-only
      hide-footer
      hide-header
    >
      <b-card>
        <div slot="header">
          <span v-text="$lang.create_new_parvandeh" />
        </div>

        <b-tabs>
          <b-tab :lazy="true" active>
            <template v-slot:title>{{
              $lang.create_parvandeh_for_new_user
            }}</template>
            <AddTerm
              :title="$lang.create_parvandeh_for_new_user"
              :parentPermissions="permissions"
              @closeModal="closeAddModal"
              @getData="getData"
            />
          </b-tab>
          <b-tab :lazy="true">
            <template v-slot:title>{{
              $lang.create_parvandeh_for_active_user
            }}</template>
            <AddCooperatorParvandehForm
              :parentPermissions="permissions"
              @closeModal="closeAddModal"
              @getData="getData"
            />
          </b-tab>
        </b-tabs>
      </b-card>
    </b-modal>
    <b-modal
      no-close-on-backdrop
      variant="primary"
      header-bg-variant="primary"
      content-class="border-primary"
      v-model="reportsModal"
      size="xl"
      ok-only
      hide-footer
      hide-header
    >
      <ParvandehReportsList
        :parvandehCode="reportParvandehCode"
        :saltFileName="reportParvandehNumber"
        @close="reportsModal = false"
      />
    </b-modal>
    <Confirm
      :title="$lang.profileLang.refresh_parvandeh_status"
      :description="refreshParvandehStatusConfirmDescription"
      v-model="refreshParvandehStatusConfirmModal"
      :ok-title="$lang.yes"
      :cancel-title="$lang.no"
      dynamicClass=""
      :loadingSpinnerText="$lang.updating_data"
      :loading="refreshParvandehStatusLoading"
      :preventDefault="true"
      @ok="refreshParvandehStatus()"
      @cancel="refreshParvandehStatusConfirmModal = false"
    />
    <ParvandehStatusModal
      :headerIcon="false"
      target="person"
      :openModal="showDetailModal"
      :parentParvandehCode="currentParvandehCode"
      @destroyed="destroyedParvandehStatusModal"
    />
    <b-modal
      no-close-on-backdrop
      variant="primary"
      header-bg-variant="primary"
      content-class="border-primary"
      v-model="uploadReportModal"
      size="md"
      ok-only
      hide-header
      hide-footer
    >
      <ReportFormPerson
        :title="`${$lang.upload_report_for} ${uploadReportPersonName}`"
        resource="parvandeh"
        :resourceCode="uploadReportParvandehCode"
        :parvandehCode="uploadReportParvandehCode"
        :acceptFormats="uploadReportAcceptFormats"
        @close="uploadReportModal = false"
      />
    </b-modal>
  </div>
</template>

<script>
import { ProfileBoxPopupWrapper } from "@/components/re-design";
import SearchCard from "@/components/base/searchCard";
import AddTerm from "./forms/addTerm.vue";
import AddCooperatorParvandehForm from "./forms/addCooperatorParvandehForm.vue";
import EditCooperatorParvandehForm from "./forms/editCooperatorParvandehForm.vue";
import ParvandehStatusModal from "./status/detail.vue";
import ParvandehReportsList from "@/components/global/ParvandehReportsList";
import Confirm from "@/components/base/confirm";
import ReportFormPerson from "@/components/global/ReportFormPerson";
import ExpandButton from "@/components/global/ExpandButton";
import { pathOr, includes } from "ramda";
import {
  isAdmin,
  calcPercentage,
  createDateFormat,
  goToRoute,
  generateApiUrl,
} from "@/shared/utils";

export default {
  components: {
    SearchCard,
    AddTerm,
    AddCooperatorParvandehForm,
    EditCooperatorParvandehForm,
    ParvandehStatusModal,
    ParvandehReportsList,
    Confirm,
    ReportFormPerson,
    ExpandButton,
    ProfileBoxPopupWrapper,
  },
  data() {
    return {
      hiddenFields: [
        "created_at.jalali",
        "created_by",
        "updated_by",
        "updated_at",
      ],
      refreshParvandehStatusLoading: false,
      showDetailModal: false,
      currentParvandehCode: null,
      refreshParvandehStatusConfirmModal: false,
      parvandehName: null,
      parvandehCode: null,
      permissions: [],
      parvandehNumberParam: this.$route.params.parvandeh_number,
      addModal: false,
      editModal: false,
      reportsModal: false,
      reportParvandehCode: null,
      reportParvandehNumber: null,
      uploadReportModal: false,
      uploadReportParvandehCode: null,
      uploadReportPersonName: "",
      uploadReportAcceptFormats: [
        {
          caption: "عکس",
          value: "1MB",
        },
        {
          caption: "مجموعه آفیس",
          value: "20MB",
        },
      ],
      otherData: null,
    };
  },
  computed: {
    refreshParvandehStatusConfirmDescription() {
      return `فرایند بروزرسانی داده‌های وضعیت تکمیل پرونده زمانبر است این برزورسانی فقط برای پروند‌های جدید اجرا میشود و داده‌های آن بعد از چند دقیقه بستگی به تعداد پرونده‌های جدید در دسترس خواهد بود .
      <br><br><b>آیا از اجرای فرایند اطمینان دارید ؟</b>`;
    },
    url() {
      /* guidance: check if has parvandeh number param get just get parvandeh by this number */
      const queryString = this.parvandehNumberParam
        ? { search_txt_parvandeh_number: this.parvandehNumberParam }
        : {};
      const parvandehService =
        this.$route.name === "parvandeh_archive"
          ? "parvandeh_archive"
          : "parvandeh";
      const url = generateApiUrl(
        ["profile", parvandehService],
        [],
        queryString
      );
      return url;
    },
    filterCache() {
      return this.parvandehNumberParam ? false : true;
    },
    extraButtons() {
      return [
        /* {
          name: "createNewParvandehForTerm",
          condition: isAdmin(this.permissions),
          title: this.$lang.create_new_parvandeh,
          click: this.showAddModal,
          iconName: "folder-plus-outline",
        }, */
        /* {
          name: "createNewParvandeh",
          condition: isAdmin(this.permissions),
          title: this.$lang.profileLang.create_new_parvandeh,
          click: this.showAddModal,
          iconName: "folder-plus-outline",
        }, */
        {
          name: "refreshParvandehStatus",
          condition: this.$route.name === "parvandeh",
          title: this.$lang.show_parvandeh_archive,
          click: this.goToParvandehRoute,
          iconName: "archive-eye-outline",
        },
        {
          name: "refreshParvandehStatus",
          condition: this.$route.name === "parvandeh_archive",
          title: this.$lang.show_parvandeh_active,
          click: this.goToParvandehRoute,
          iconName: "folder-multiple-outline",
        },
      ];
    },
    isParvandehArchive() {
      return this.$route.name === "parvandeh_archive";
    },
    title() {
      return this.$route.name === "parvandeh_archive"
        ? this.$lang.parvandeh_archive
        : this.$lang.searchParvandeh;
    },
  },
  methods: {
    pathOr,
    includes,
    isAdmin,
    calcPercentage,
    createDateFormat,
    goToRoute,
    showPdfPerson(item) {
      const routerData = this.$router.resolve({
        name: "DesignPdfPage",
        params: {
          code: pathOr(null, ["person", "code"], item),
        },
      });
      window.open(routerData.href, "_blank");
    },
    showReports(item) {
      this.reportParvandehCode = pathOr(null, ["code"], item);
      this.reportParvandehNumber = pathOr(null, ["parvandeh_number"], item);
      this.reportsModal = true;
    },
    getData() {
      this.$refs.searchParvandeh.getItems();
    },
    async refreshParvandehStatus() {
      try {
        this.refreshParvandehStatusLoading = true;
        const url =
          this.$config.api_url + this.$config.profile.refresh_parvandeh_status;
        await this.$httpService.patch(url);
        const message =
          "کلیه داده‌های وضعیت پرونده و میزان نقایص آنها برای بروز رسانی به لیست اجرا اضافه شد لطفا شکیبا باشید این فرایند زمانبر است بعد از  فاصله زمانی مناسب داده لیست را بروزرسانی نمائید تا آخرین وضعیت پروند‌های بروز شده را مشاهده نمائید";
        this.$notify.success(message);
        this.refreshParvandehStatusConfirmModal = false;
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.refreshParvandehStatusLoading = false;
      }
    },
    showIncompleteParvandehModal(item) {
      this.currentParvandehCode = pathOr(null, ["code"], item);
      this.showDetailModal = true;
    },
    destroyedParvandehStatusModal() {
      this.currentParvandehCode = null;
      this.showDetailModal = false;
    },
    generateParvandehTitle(item) {
      const parvandehNumber = pathOr("", ["parvandeh_number"], item);
      const term = pathOr("", ["term", "caption"], item);
      return `پرونده شماره <b>${parvandehNumber}</b> - ${term}`;
    },
    isNotCooperation(item) {
      return pathOr(null, ["term", "license_id"], item);
    },
    showAddModal() {
      this.addModal = true;
    },
    closeAddModal() {
      this.addModal = false;
    },
    showEditModal(item) {
      this.parvandehName = this.generateParvandehTitle(item);
      this.parvandehCode = pathOr(null, ["code"], item);
      this.editModal = true;
    },
    updatePermissions(data) {
      this.permissions = [...data];
    },
    getFullName(item) {
      const name = pathOr("", ["person", "name"], item);
      const family = pathOr("", ["person", "family"], item);
      return `${name} ${family}`;
    },
    showRefreshParvandehStatusConfirmModal() {
      this.refreshParvandehStatusConfirmModal = true;
    },
    showUploadReportModal(item) {
      this.uploadReportParvandehCode = pathOr(null, ["code"], item);
      const name = pathOr("", ["person", "name"], item);
      const family = pathOr("", ["person", "family"], item);
      this.uploadReportPersonName = `${name} ${family}`;
      this.uploadReportModal = true;
    },
    updateOtherData(data) {
      this.otherData = data;
    },
    goToParvandehRoute() {
      const name = this.isParvandehArchive ? "parvandeh" : "parvandeh_archive";
      goToRoute(name, {}, {}, false);
    },
    generateImage(item) {
      const imageData = pathOr([], ["img_kind"], item);
      const address = pathOr(
        "",
        ["address"],
        imageData.find((row) => row.type === "thumb")
      );
      return address;
    },
    goToReportDashboard(item) {
      const image = this.generateImage(item);
      const name = pathOr("", ["person", "name"], item);
      const family = pathOr("", ["person", "family"], item);
      const data = [
        {
          code: pathOr(null, ["code"], item),
          parvandehNumber: pathOr(null, ["parvandeh_number"], item),
          fullName: `${name} ${family}`,
          image,
          termCaption: pathOr("", ["term", "caption"], item),
        },
      ];
      localStorage.setItem("dashboard-parvandeh-codes", JSON.stringify(data));
      goToRoute("report_dashboard", {}, {}, false);
    },
  },
};
</script>

<style scoped lang="scss">
.grid-img-crd {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  img {
    width: 95px;
    height: auto;
  }
}
.fs_1_3rem {
  font-size: 20px;
}
.w_h_35 {
  width: 35px;
  height: 35px;
}
</style>
